<div (click)="menu?.toggle($event)" class="d-flex align-items-center">
  <div class="user-info d-inline-block">
    <span class="d-block user-name">{{ user?.name }}</span>
    <span class="d-block user-email">{{ user?.email }}</span>
  </div>

  <div class="menu-cta">
    <i class="fas fa-ellipsis-v"></i>
  </div>

  <p-overlayPanel styleClass="cap-overlay-panel header-title-bar" #menu appendTo="body">
    <div class="user-menu">
      <ul class="user-menu__items">
        <ng-container *ngFor="let item of menuItems">
          <li (click)="executeCommand(item); menu?.hide()">
            <i [className]="item?.icon"></i>
            <span>{{ item?.label | translate }}</span>
          </li>
        </ng-container>
      </ul>

      <ul *ngIf="tenantsItems" class="user-menu__item--header">
        <div class="pt-4">
          <li>
            <span>{{ 'mdn.general.tenant.switch' | translate }}</span>
          </li>
        </div>
      </ul>

      <ul *ngIf="tenantsItems" class="user-menu__items">
        <ng-container *ngFor="let item of tenantsItems">
          <li (click)="switchTenant(item); menu?.hide()">
            <span>{{ item?.name }}</span>
          </li>
        </ng-container>
      </ul>
    </div>
  </p-overlayPanel>
</div>
